import {Presenter} from '../../Support/with_presenter';
import {MeService} from '../../Network/MeService';
import {NetworkRequestStatus, NetworkResult} from '../../Network/NetworkResult';
import {Me} from '../../Models/Me';

export class FeedbackPresenter implements Presenter {
    private me: NetworkResult<Me> | null = null;

    public get userId(): string | undefined {
        if (!this.me || this.me?.status !== NetworkRequestStatus.Success) {
            return undefined;
        }
        return this.me.data.email;
    }

    constructor(private meService: MeService) {}

    public async mount(): Promise<void> {
        try {
            this.me = await this.meService.get();
        } catch (e) {
            this.me = null;
        }
    }

    public unmount(): void {
        /* Noop */
    }
}
